/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Context_Cat_3Inputs */

const en_mk_context_cat_3 = /** @type {(inputs: Mk_Context_Cat_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbidden Words`)
};

const id_mk_context_cat_3 = /** @type {(inputs: Mk_Context_Cat_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kata Terlarang`)
};

/**
* | output |
* | --- |
* | "Forbidden Words" |
*
* @param {Mk_Context_Cat_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_context_cat_3 = /** @type {((inputs?: Mk_Context_Cat_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Context_Cat_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_context_cat_3(inputs)
	return en_mk_context_cat_3(inputs)
});